import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 24px;
    width: 544px;
    height: 707px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      max-width: 100vw;
      padding: 16px;
      height: auto;
      min-height: 500px;
    }
  `}
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    margin: 0 0 8px 0;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: normal;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    margin: 0 0 24px 0;
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: normal;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxxs};
      margin: 0 0 16px 0;
    }
  `}
`;

export const CropContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 480px;
    height: 480px;
    background: ${theme.v2.colors.neutral.lowDark};
    overflow: hidden;
    user-select: none;
    -webkit-user-select: none;
    touch-action: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin: 0 auto;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      max-width: calc(100vw - 32px);
      height: auto;
      aspect-ratio: 1;
      min-height: 280px;
    }
  `}
`;

export const Image = styled.img`
  ${({ $transform, $isDragging }) => css`
    position: absolute;
    max-width: none;
    max-height: none;
    transform-origin: center center;
    pointer-events: none;
    user-select: none;
    -webkit-user-drag: none;
    transform: ${$transform};
    cursor: ${$isDragging ? 'grabbing' : 'grab'};
  `}
`;

export const CropOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 32, 68, 0.6);
  pointer-events: none;
`;

export const CropCircle = styled.div`
  ${({
    theme, $left, $top, $size,
  }) => css`
    position: absolute;
    border: 2px solid ${theme.v2.colors.brand.primaryMedium};
    border-radius: 50%;
    box-sizing: border-box;
    pointer-events: none;
    left: ${$left}px;
    top: ${$top}px;
    width: ${$size}px;
    height: ${$size}px;
    
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: 50%;
      box-shadow: 0 0 0 9999px rgba(31, 32, 68, 0.6);
      pointer-events: none;
    }
  `}
`;

export const CornerHandle = styled.div`
  ${({ theme, cursor, position }) => css`
    position: absolute;
    width: 40px;
    height: 40px;
    pointer-events: all;
    cursor: ${cursor || 'nwse-resize'};
    z-index: 10;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      background: ${theme.v2.colors.brand.primaryMedium};
    }
    
    &::before {
      width: 24px;
      height: 4px;
    }
    
    &::after {
      width: 4px;
      height: 24px;
    }
    
    ${position === 'top-left' && `
      top: -2px;
      left: -2px;
      
      &::before {
        top: 0;
        left: 0;
      }
      
      &::after {
        top: 0;
        left: 0;
      }
    `}
    
    ${position === 'top-right' && `
      top: -2px;
      right: -2px;
      
      &::before {
        top: 0;
        right: 0;
      }
      
      &::after {
        top: 0;
        right: 0;
      }
    `}
    
    ${position === 'bottom-left' && `
      bottom: -2px;
      left: -2px;
      
      &::before {
        bottom: 0;
        left: 0;
      }
      
      &::after {
        bottom: 0;
        left: 0;
      }
    `}
    
    ${position === 'bottom-right' && `
      bottom: -2px;
      right: -2px;
      
      &::before {
        bottom: 0;
        right: 0;
      }
      
      &::after {
        bottom: 0;
        right: 0;
      }
    `}
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 32px;
    flex-shrink: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-top: 24px;
      gap: 12px;
      flex-direction: column-reverse;
      width: 100%;

      button {
        width: 100%;
      }
    }
  `}
`;
